const API_URL = process.env.REACT_APP_API_URL || 'https://api.tcf-studio.dev';

const getAuthToken = () => localStorage.getItem('authToken');

const getHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const createKey = async ({ name, allowed_models, spending_limit_cents, spending_period, is_account_key }) => {
  const res = await fetch(`${API_URL}/apikeys`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ name, allowed_models, spending_limit_cents, spending_period, is_account_key }),
  });
  return res.json();
};

export const listKeys = async () => {
  const res = await fetch(`${API_URL}/apikeys`, { headers: getHeaders() });
  return res.json();
};

export const revokeKey = async (keyId) => {
  const res = await fetch(`${API_URL}/apikeys/${keyId}/revoke`, {
    method: 'POST',
    headers: getHeaders(),
  });
  return res.json();
};

export const deleteKey = async (keyId) => {
  const res = await fetch(`${API_URL}/apikeys/${keyId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return res.json();
};

export const getKeyStats = async (keyId) => {
  const res = await fetch(`${API_URL}/apikeys/${keyId}/stats`, { headers: getHeaders() });
  return res.json();
};
